import React from "react";
import {
  JobApplication,
  JobApplicationStatus,
} from "../../../Entities/job-application.entity";
import Table from "antd/es/table";
import type { ColumnsType } from "antd/es/table";
import { BlockOutlined } from "@ant-design/icons";
import { formatDate } from "../../../Utils/generic-functions";

interface ApplicationTableProps {
  applications: JobApplication[];
}

const colors = ["blue", "emerald", "slate"];

const getStatusColor = (status: JobApplicationStatus) => {
  switch (status) {
    case "applied":
      return "default";

    case "shortlisted":
      return "warning";

    case "interview":
      return "purple";

    case "rejected":
      return "danger";

    case "accepted":
      return "success";

    case "hired":
      return "success";

    default:
      return "default";
  }
};

const ApplicationTable: React.FC<ApplicationTableProps> = ({
  applications,
}) => {
  const sortedApplications = [...applications].sort(
    (a, b) =>
      new Date(b.applied_date).getTime() - new Date(a.applied_date).getTime(),
  );

  const columns: ColumnsType<JobApplication> = [
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      render: (text, record) => {
        return (
          <div className="profile__position-cell">
            <div
              className={`profile__position-icon profile__position-icon--${colors[Math.floor(Math.random() * colors.length)]}`}
            >
              <BlockOutlined />
            </div>
            <span className="profile__position-name">{record.jobPost.title}</span>
          </div>
        );
      },
    },
    {
      title: "Applied Date",
      dataIndex: "date",
      key: "createdAt",
      render: (text, record) => {
        return (
          <span className="profile__date">{formatDate(record.applied_date)}</span>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: [
        { text: "Applied", value: "applied" },
        { text: "Shortlisted", value: "shortlisted" },
        { text: "Interview", value: "interview" },
        { text: "Accepted", value: "accepted" },
        { text: "Hired", value: "hired" },
        { text: "Rejected", value: "rejected" },
      ],
      onFilter: (value, record) => record.status === value,
      render: (status, record) => (
        <span
          className={`profile__status-tag profile__status-tag--${getStatusColor(record.status)}`}
        >
          {status}
        </span>
      ),
    },
  ];

  return (
    <div>
      <Table<JobApplication>
        dataSource={sortedApplications}
        columns={columns}
        pagination={{ pageSize: 10, showSizeChanger: false }}
        className="profile__table"
      />
    </div>
  );
};

export default ApplicationTable;
